import { LinkType } from "../types";

export default class Link {
  length: number;
  toNodeName: string;
  constructor(options: LinkType) {
    this.length = options.length;
    this.toNodeName = options.to;
  }
}
